import { createGetEndpoint } from '@sonar-software/sonar-http';

export const getSetupAuditTrailSections = createGetEndpoint<void, Array<string>>(
	'/api/v3/setup-audit-trail/sections'
);
